import i18n from "../../../i18n"

export const professors =
{
    department: i18n.t("dai_department"),
    professors:
        [
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1525/1173-achat-2.jpg',
                fname: i18n.t('alexandros'),
                lname: i18n.t('chatzigeorgiou'),
                title: i18n.t('Κοσμήτορας'),
                tel: '2310 891.886',
                email: 'achat@uom.edu.gr',
                building: 'Γ3',
                office: '326'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1526/1678-ealex-2.jpg',
                fname: i18n.t('evgenia'),
                lname: i18n.t('alexandropoulou'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.896',
                email: 'ealex@uom.edu.gr',
                building: 'Γ5',
                office: '526'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1553/1694-mavla_new-2.jpg',
                fname: i18n.t('maro'),
                lname: i18n.t('vlachopoulou'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.867',
                email: 'mavla@uom.edu.gr',
                building: 'Γ2',
                office: '221'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1531/3460-geor-1.png',
                fname: i18n.t('christos'),
                lname: i18n.t('georgiadis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.869',
                email: 'geor@uom.edu.gr',
                building: 'Γ3',
                office: '321'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1522/1183-gevan-2.jpg',
                fname: i18n.t('georgios'),
                lname: i18n.t('evaggelidis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.844',
                email: 'gevan@uom.edu.gr',
                building: 'Γ2',
                office: '228'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1510/1200-kmarg-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('margaritis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.891',
                email: 'kmarg@uom.edu.gr',
                building: 'Γ5',
                office: '531'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1527/1847-Mavridis-2.jpg',
                fname: i18n.t('ioannis'),
                lname: i18n.t('mavridis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.868',
                email: 'mavridis@uom.edu.gr',
                building: 'Γ4',
                office: '427'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1539/3091-nikolai-2.png',
                fname: i18n.t('ioannis'),
                lname: i18n.t('nikolaidis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.878',
                email: 'nikolai@uom.edu.gr',
                building: 'Γ3',
                office: '332'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1528/5191-Refanidis-2.png',
                fname: i18n.t('ioannis'),
                lname: i18n.t('refanidis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.859',
                email: 'yrefanid@uom.edu.gr',
                building: 'Γ2',
                office: '226'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1513/1113-manos-2.jpg',
                fname: i18n.t('manos'),
                lname: i18n.t('roumeliotis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.894',
                email: 'manosz@uom.edu.gr',
                building: 'Γ5',
                office: '525'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1530/1210-samaras-2.jpg',
                fname: i18n.t('nikolaos'),
                lname: i18n.t('samaras'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.866',
                email: 'samaras@uom.edu.gr',
                building: 'Γ2',
                office: '426'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1519/1567-MayaSatratzemi-2.jpg',
                fname: i18n.t('maria'),
                lname: i18n.t('satratzemi'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.897',
                email: 'maya@uom.edu.gr',
                building: 'Γ5',
                office: '524'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1536/1219-stiakakis-2.jpg',
                fname: i18n.t('emmanouil'),
                lname: i18n.t('steiakakis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.643',
                email: 'stiakakis@uom.edu.gr',
                building: 'Γ3',
                office: '328'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1538/1220-tambouris-2.jpg',
                fname: i18n.t('euthimios'),
                lname: i18n.t('tampouris'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.889',
                email: 'tambouris@uom.edu.gr',
                building: 'Γ4',
                office: '421'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1532/4825-Hristou-Varsakelis_ed-2.jpg',
                fname: i18n.t('dimitrios'),
                lname: i18n.t('hristou_varsakelis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.721',
                email: 'dcv@uom.edu.gr',
                building: 'Γ4',
                office: '432'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1546/3134-kvergidis-2.png',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('vergidis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.637',
                email: 'kvergidis@uom.edu.gr',
                building: 'Γ3',
                office: '322'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('apostolos'),
                lname: i18n.t('dasilas'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.883',
                email: 'dasilas@uom.edu.gr',
                building: 'Γ5',
                office: '522'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1529/1194-kaskalis-2.jpg',
                fname: i18n.t('theodoros'),
                lname: i18n.t('kaskalis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.885',
                email: 'kaskalis@uom.edu.gr',
                building: 'Γ3',
                office: '323'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1543/2972-Kitsios-2.png',
                fname: i18n.t('fotios'),
                lname: i18n.t('kitsios'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.718',
                email: 'kitsios@uom.edu.gr',
                building: 'Γ2',
                office: '232'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1545/5382-5364-mamatas-better-2.png',
                fname: i18n.t('eleftherios'),
                lname: i18n.t('mamatas'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.709',
                email: 'emamatas@uom.edu.gr',
                building: 'Γ5',
                office: '530'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1535/4778-stelios-2.png',
                fname: i18n.t('stylianos'),
                lname: i18n.t('xinogalos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.895',
                email: 'stelios@uom.edu.gr',
                building: 'Γ5',
                office: '527'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1550/10399-papadimitriou5-2.jpg',
                fname: i18n.t('panagiotis'),
                lname: i18n.t('papadimitriou'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.727',
                email: 'papadimitriou@uom.edu.gr',
                building: 'Γ4',
                office: '432'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1524/12809-sifaleras-2.jpg',
                fname: i18n.t('aggelos'),
                lname: i18n.t('sifaleras'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.884',
                email: 'sifalera@uom.edu.gr',
                building: 'Γ4',
                office: '428'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1533/1218-stavrop-2.jpg',
                fname: i18n.t('antonios'),
                lname: i18n.t('stauropoulos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.862',
                email: 'stavrop@uom.edu.gr',
                building: 'Γ2',
                office: '227'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1544/1197-kfouskas-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('fouskas'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.845',
                email: 'kfouskas@uom.edu.gr',
                building: 'Γ4',
                office: '430'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1542/5331-Psannis-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('psannis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.737',
                email: 'kpsannis@uom.edu.gr',
                building: 'Γ5',
                office: '521'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/6477/4728-abatzoglou-2.jpg',
                fname: i18n.t('apostolos'),
                lname: i18n.t('ampatzoglou'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.809',
                email: 'a.ampatzoglou@uom.edu.gr',
                building: 'Γ3',
                office: '330'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/10789/11801-Giannoutakhs_Kwstas_340x340-2.png',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('giannoutakis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.810',
                email: 'kgiannou@uom.edu.gr',
                building: 'Γ3',
                office: '331'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1547/1184-gkoloniari-2.jpg',
                fname: i18n.t('georgia'),
                lname: i18n.t('koloniari'),
                title: i18n.t('epikouriKathigitria'), tel: '2310 891.887',
                email: 'gkoloniari@uom.edu.gr',
                building: 'Γ4',
                office: '432'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1549/1208-mmadas-2.jpg',
                fname: i18n.t('michail'),
                lname: i18n.t('mantas'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.773',
                email: 'mmadas@uom.edu.gr',
                building: 'Γ5',
                office: '520'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1540/1217-spetrido-2.jpg',
                fname: i18n.t('sofia'),
                lname: i18n.t('petridou'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.639',
                email: 'spetrido@uom.edu.gr',
                building: 'Γ3',
                office: '325'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1537/1191-iliass-2.jpg',
                fname: i18n.t('ilias'),
                lname: i18n.t('sakellariou'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.858',
                email: 'iliass@uom.edu.gr',
                building: 'Γ5',
                office: '529'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('stavros'),
                lname: i18n.t('souravlas'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.872',
                email: 'sourstav@uom.edu.gr',
                building: 'Γ4',
                office: '425'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1534/8867-pfoul_2021-2.jpg',
                fname: i18n.t('panagiotis'),
                lname: i18n.t('fouliras'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.843',
                email: 'pfoul@uom.edu.gr',
                building: 'Γ2',
                office: '230'
            }
        ]

}